<template>
  <div id="app">
    <!-- <button @click="handleSetSize('2')">换肤(小)</button>
		<button @click="handleSetSize('3')">换肤(中)</button>
		<button @click="handleSetSize('4')">换肤(大)</button> -->
    <!-- <div class="form-title">nihao</div> -->
    <commonTip :iType="1" :titleStr="tipStr" v-show="isShowWsState"></commonTip>
    <audio id="audio" :src="nowAudioUrl" style="display: none"></audio>
    <audio
      id="newUserAudio"
      :src="newUserAudioUrl"
      style="display: none"
    ></audio>
    <audio id="keyAudio" :src="keyAudioUrl" style="display: none"></audio>
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import commonTip from "./components/commonTip.vue";
import { codeAndTips } from "@/utils/websocket.js";
export default {
  name: "App",
  data() {
    return {
      tipStr: "",
      isShowWsState: false,
      isShowLoad: false,
      beforeUnloadTime: 0,
      gapTime: 0,
    };
  },

  components: {
    commonTip,
  },

  computed: {
    // nowWsState() {
    // 	console.log('app computed nowWsState tag = ', this.$store.state.authority.wsStateTag)

    // 	return this.$store.state.authority.wsStateTag
    // 	// return this.$store.state.isOnline
    // },

    nowAudioUrl() {
      console.log(
        "app computed nowAudioUrl = ",
        localStorage.getItem("flickerAudioUrl")
      );
      return localStorage.getItem("flickerAudioUrl");
    },
    newUserAudioUrl() {
      console.log(
        "app computed newUserAudioUrl = ",
        localStorage.getItem("newaudioUrl")
      );
      return localStorage.getItem("newaudioUrl");
    },
    keyAudioUrl() {
      console.log(
        "app computed keyAudioUrl = ",
        localStorage.getItem("keyAudioUrl")
      );
      return localStorage.getItem("keyAudioUrl");
    },

    nowTheme() {
      return this.$store.state.currentTheme;
    },

    isOnline() {
      return this.$store.state.isOnline;
    },
    pingTips() {
      return this.$store.getters.getPingTips;
    },

    fontSize() {
      return this.$store.state.fontSize;
    },
  },

  watch: {
    // nowWsState: function (newVal, oldVal) {
    // 	console.log('app watch nowWsState newVal = ', newVal)
    // 	console.log('app watch nowWsState oldVal = ', oldVal)

    // 	if (newVal == 2 && oldVal == 1) {
    // 		if(localStorage.getItem("token")!=null || localStorage.getItem("token")!='null'){
    // 			this.tipStr = '网络已断开，正在重连中...'
    // 			this.isShowWsState = true
    // 			this.util.playErrTipAudio()
    // 		}

    // 		//connectWebsocket2()

    // 	} else if (newVal == 1 && oldVal == 2) {
    // 		this.tipStr = '网络已连接成功'
    // 		this.isShowWsState = true

    // 		setTimeout(() => {
    // 			console.log('app watch nowWsState setTimeout')
    // 			this.isShowWsState = false
    // 		}, 5000);
    // 	}else if(newVal == 0){
    // 		// setTimeout(() => {
    // 		// 	console.log('app watch nowWsState setTimeout')

    // 		// }, 2000);

    // 		this.isShowWsState = false
    // 	}
    // },

    nowTheme(newVal, oldVal) {
      console.log("app watch nowTheme newVal = ", newVal);
      console.log("app watch nowTheme oldVal = ", oldVal);
      if (newVal === "0") {
        import("./theme/theme1.css");
      } else if (newVal === "1") {
        import("./theme/theme2.css");
      }
    },

    pingTips(newVal, oldVal) {
      console.log("app watch pingTips newVal = ", newVal);
      console.log("app watch pingTips oldVal = ", oldVal);
      if (newVal.code != null) {
        this.tipStr = newVal.tipsText;
        this.isShowWsState = true;
        if (newVal.code == codeAndTips.offlineCode) {
          this.util.playErrTipAudio();
        } else if (newVal.code == codeAndTips.connectedCode) {
          setTimeout(() => {
            this.isShowWsState = false;
          }, 2000);
        }
      } else {
        this.isShowWsState = false;
      }
    },

    // fontSize(newVal,oldVal) {
    // 	console.log('app watch fontSize newVal = ', newVal)
    // 	console.log('app watch fontSize oldVal = ', oldVal)

    // 	if(newVal != null) {
    // 		window.document.documentElement.setAttribute('data-size', newVal)
    // 	}
    // }

    // isOnline(newVal, oldVal) {
    // 	var self = this;
    // 	let wsState = self.util.getLocalWsState();
    // 	if (newVal == true && oldVal == false) {
    // 		if (wsState == '2') {
    // 			setTimeout(() => {
    // 				connectWebsocket2()

    // 				// self.netWork();
    // 			}, 2000);
    // 		}
    // 	}
    // }
  },

  created() {
    console.log(
      "app created function isVisibility = ",
      document.visibilityState
    );

    let fontSize = localStorage.getItem("fontSize");
    if (!fontSize) {
      window.document.documentElement.setAttribute("data-size", "2");
    } else {
      window.document.documentElement.setAttribute("data-size", fontSize);
    }

    let theme = this.$store.state.currentTheme;
    console.log("app created function theme = ", theme);
    if (theme === "0") {
      import("./theme/theme1.css");
    } else if (theme === "1") {
      import("./theme/theme2.css");
    }

    // 获取特殊显示关键字
    this.getSpecialDisplayKeywords();

    window.addEventListener("storage", function (e) {
      let audio;
      console.log("storage e==========", e);
      if (e.key == "fontSize") {
        window.document.documentElement.setAttribute("data-size", e.newValue);
      } else if (e.key == "flickeraudiourl") {
        audio = document.getElementById("audio");
        audio.src = e.newValue;
      } else if (e.key == "newaudiourl") {
        audio = document.getElementById("newUserAudio");
        audio.src = e.newValue;
      } else if (e.key == "keyAudioUrl") {
        audio = document.getElementById("keyAudio");
        audio.src = e.newValue;
        console.log("关键词提示音url：", audio.src);
      } else if (e.key == "volume") {
        const volume = e.newValue;
        const audioList = document.querySelectorAll("audio");
        for (const item of audioList) {
          item.volume = volume;
        }
        console.log("App.vue created storage", volume, audioList);
      }
    });
  },

  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.addEventListener("unload", (e) => this.unloadHandler(e));

    if (window.performance.navigation.type == 1) {
      if (this.util.getLoginTip() === "1") {
        if (this.$route.path === "/home") {
          return;
        }

        // connectWebsocket2()
      }
    } else {
      console.log("首次被加载！");
    }
  },

  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },

  methods: {
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    async unloadHandler() {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime;
      // debugger
      /*if (this.gapTime <= 5) {
					if (this.util.getLocalAccount().status == 1) {
						var api = "/manager/user/logOut";
						await this.util.postRequest({
							url: api,
							method: "POST",
						});
					}
				}*/
    },

    switchMode(mode) {
      if (!mode || mode === "dark") {
        window.document.documentElement.setAttribute("data-theme", "dark");
      } else {
        window.document.documentElement.setAttribute("data-theme", "bright");
      }
    },

    handleSetSize(size) {
      window.document.documentElement.setAttribute("data-size", size);
    },
    setLocalFlickerUrl(url) {
      this.$store.state.flickerAudioUrl = url;
    },

    // 获取特殊显示关键字
    async getSpecialDisplayKeywords() {
      try {
        const api = "/manager/sysconf/getSpecialDisplayKeywords";
        const res = await this.util.postRequest({
          url: api,
          method: "POST",
        });
        console.log("App.vue getSpecialDisplayKeywords res = ", res);
        if (res.resultCode === "10000" && res.data) {
          // 将分号分隔的字符串转换为数组
          const keywordsArray = res.data.split(";").filter(keyword => keyword.trim() !== "");
          this.$store.state.specialDisplayKeywords = keywordsArray;
          console.log("App.vue specialDisplayKeywords = ", keywordsArray);
        } else {
          console.warn("获取特殊显示关键字失败:", res.desc);
          this.$store.state.specialDisplayKeywords = [];
        }
      } catch (error) {
        console.error("获取特殊显示关键字异常:", error);
        this.$store.state.specialDisplayKeywords = [];
      }
    },
  },
};
</script>

<style lang="scss">
// @import './mixin.scss';

html {
  overflow: hidden;
  background: rgba(90, 156, 248, 0.8);
}

#app,
body {
  /* background-color: yellow; */
  width: 100%;
  height: 100%;
  // min-width: 75rem;
  // min-height: 62.5rem;
  overflow: hidden;
  /* overflow-x: scroll; */
  // background: linear-gradient(to bottom right, #7a88ff, #7affaf);
  /* text-align: center; */
}

* {
  margin: 0;
  padding: 0;
}

.form-title {
  font-size: 18px;
  color: cyan;
  // @include header_font_color();
  // @include important-text;
  @include change_size($font_size_normal);
}

/* body {
		width: 80vw;
		height: 100vh;
		min-width: 75rem;
		overflow: hidden;
		overflow-x: scroll;
		background: linear-gradient(to bottom right, #7a88ff, #7affaf);
		text-align: center;
	} */

/* body {
		background-color: yellow;
	} */
</style>
